export default __webpack_public_path__ + "static/media/image_placeholder.b3380949.svg";